import { render, staticRenderFns } from "./riderzl.vue?vue&type=template&id=faecbdb4&"
import script from "./riderzl.vue?vue&type=script&lang=js&"
export * from "./riderzl.vue?vue&type=script&lang=js&"
import style0 from "./riderzl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports